import CommonButton from "components/atoms/buttons/CommonButton/CommonButton";
import { useNavigate } from "react-router-dom";
import { EmptyGuideBoxContainer } from "./EmptyGuideBox.style";

const EmptyGuideBox = () => {
  const navigate = useNavigate();
  return (
    <EmptyGuideBoxContainer>
      <h2>어떠한 과거 url정보도 가지고오지 못했어요!</h2>
      <CommonButton label={"홈으로 가기"} handleClick={() => navigate("/")}/>
    </EmptyGuideBoxContainer>
  );
};

export default EmptyGuideBox;